<template>
<div :style="styleComputed" class="fixed-top height-100" :class="{'bg-orange height-auto' : clicked}">
    <b-navbar toggleable="lg" class="top-header bg-mobile-dark" id="header">
        <b-navbar-brand to="/"> 
            <div class="logo-box">
                <div class="logo-bauhaus-white" :style="opacityLogoReverse" >
                    <b-img :style="opacityLogoReverse" :src="`/wp-content/themes/rhiza/dist/assets/logo.png`" alt="Bauhaus Brasil" />
                </div>
                <div class="logo-bauhaus-red" :style="opacityLogo">
                    <b-img :style="opacityLogo" :src="`/wp-content/themes/rhiza/dist/assets/logo-red.png`" alt="Bauhaus Brasil" />
                </div>
            </div>
        </b-navbar-brand>
        
        <div>
            <b-img
                src="/wp-content/themes/rhiza/dist/assets/lupa.png" 
                alt="Pesquisar" 
                :class="{'d-none': clicked, 'd-lg-none': true}" 
                style="width: 22px"
                @click="searchOpen" />

            <b-nav-toggle target="nav_collapse"></b-nav-toggle>
            <span class="d-lg-none font-glacial-bold"></span>
        </div>

        <b-collapse is-nav id="nav_collapse" :style="`max-height: 100vh; overflow: auto; margin-top: 16px;`">

            <b-navbar-nav is-nav-bar>
                <component 
                    v-bind:is="'b-nav-item'" 
                    class="font-semi-bold text-white text-uppercase text-center"
                    v-b-toggle="'nav_collapse'"
                    v-for="(page, index) in arrPages" 
                    :key="index" 
                    :to="{name: 'page', params: {page: page.slug}}" 
                    v-if="page.slug != 'concurso-de-bolsas' || (page.slug == 'concurso-de-bolsas' && concursoDate(page.slug))"  
                >
                    <div slot="button-content">
                        {{page.title}}
                    </div>
                </component>
                
                <b-nav-item-dropdown style="`margin-left:14px`" class="d-block d-lg-none font-semi-bold text-white text-uppercase text-center" text="CURSOS">
                    <b-dropdown-item class="text-center font-header-11" v-for="(d, index) in cursos" :key="index" @click="routeTo({name:'curso', params:{slug:d.slug, area:d.area}})">
                        {{d.nome}}
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

            <b-navbar-nav is-nav-bar class="ml-auto d-none d-lg-flex none-ul mt-0">
                <b-nav-item class="lupa relative">
                    <b-img 
                        src="/wp-content/themes/rhiza/dist/assets/lupa.png" 
                        alt="Pesquisar" 
                        :class="{'d-none' : clicked}" 
                        @click="searchOpen" />
                </b-nav-item>

                <b-nav-item class="menu-cursos" @click="cursosClicked()">
                    <b-img class="menu-img" :class="{'d-none' : clicked}" src="/wp-content/themes/rhiza/dist/assets/menu-orange2.png" alt="Bauhaus"/>
                    <b-img class="btn-fechar menu-img" :class="{'d-none' : !clicked}" src="/wp-content/themes/rhiza/dist/assets/fechar-menu.png" alt="Bauhaus"/>
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

    <transition mode="out-in" name="custom-classes-transition"
        enter-active-class="animated bounceInUp"
        leave-active-class="animated bounceOutDown"
    >
        <div key="cursos" class="bg-orange body-cursos container margin-top-25" v-if="clicked" id="style-1">
            <div class="row justify-content-center">

                <div class="col-12">
                    <div class="row">

                        <div class="col-6 justify-content-center fit-content">
                            <div class="row">
                                <div class="col-12 mb-5" v-for="(d, index) in cursosOrdened.slice(0, cursosOrdened.length/2)" :key="index">
                                     <div class="mb-xl-3 font-24 font-glacial-bold text-white text-uppercase">
                                        {{d}}
                                    </div>
                                    <div class="font-glacial-regular text-white text-uppercase" 
                                        v-for="(i, index) in cursos" :key="index" v-if="i.area == d" @click="routeTo({name:'curso', params:{slug:i.slug, area:i.area}})">
                                        <div class="pointer font-16 px-4 curso-nome">
                                            - {{i.nome}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-6 justify-content-center fit-content">
                            <div class="row">
                                <div class="col-12 mb-5" v-for="(d, index) in cursosOrdened.slice(cursosOrdened.length/2, cursosOrdened.length)" :key="index">
                                     <div class="mb-xl-3 font-24 font-glacial-bold text-white text-uppercase">
                                        {{d}}
                                    </div>
                                    <div class="font-glacial-regular text-white text-uppercase" 
                                        v-for="(i, index) in cursos" :key="index"
                                        v-if="i.area == d"
                                        @click="routeTo({name:'curso', params:{slug:i.slug, area:i.area}})"
                                    >
                                        <div class="pointer font-16 px-4 curso-nome">
                                            - {{i.nome}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row justify-content-end">
                <div class="col-12 col-xl-3 col-lg-3">
                    <img class="geometric" src="/wp-content/themes/rhiza/src/assets/geometric.png">
                </div>
            </div>

        </div>
    </transition>
    <transition name="slide">
        <div class="search" v-show="showSearch">
            <div class="search-inside d-flex justify-content-end align-items-center">
                <input ref="search" type="text" v-on:keyup.enter="search" v-model="searchBox">
                <b-button @click="search" class="btn-search">
                    <b-img src="/wp-content/themes/rhiza/dist/assets/lupa.png" class="height-20"></b-img>
                    <span class="d-none d-sm-block ml-2">Pesquisar</span>
                </b-button>
                <b-button @click="searchOpen">
                    <b-img src="/wp-content/themes/rhiza/dist/assets/icon-close.png" class="height-20"></b-img>
                </b-button>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
export default {
    data(){
        return{
            scrollPercentage: 0,
            clicked: false,
            concurso: false,
            logo: "logo.png",
            showSearch: false,
            searchBox: '',
            arrPages: [{
                slug: 'bauhaus',
                title: 'Bauhaus',
            },
            {
                slug: 'blog',
                title: 'Blog',
            },
            {
                slug: 'eventos',
                title: 'Eventos',
            },
            {
                slug: 'videos',
                title: 'Vídeos',
            },
            {
                slug: 'ebooks',
                title: 'E-Books',
            },
            {
                slug: 'fale-conosco',
                title: 'Fale Conosco',
            },
            {
                slug: 'unifran',
                title: 'UNIFRAN',
            },
            {
                slug: 'concurso-de-bolsas',
                title: 'Concurso de Bolsas',
            }]
        }
        
    },

    created() {
        if (this.$route.query.q) {
            this.searchBox = this.$route.query.q
            this.showSearch = true
        }

        if (this.$route.name == "pesquisar") {
            this.showSearch = true
        }
    },

    methods:{
        searchOpen(){
            this.showSearch = !this.showSearch
            if (this.showSearch) {
                this.$nextTick(() => this.$refs.search.focus())
            }
        },

        search() {
            this.$router.push({name: 'pesquisar', query: {q: this.searchBox }})
            if (this.$route.name == "pesquisar") {
                this.$router.go()
            }
        },
        
        concursoDate(p){
            var month = moment().month()

            if(month == 0 || month == 6){
                return true
            } else {
                if(p == 'concurso-de-bolsas'){
                    return false
                } else {
                    return true
                }
            }
        },
        
        cursosClicked(){
            if(this.clicked == false){
                this.clicked = true
                document.querySelector('body').classList.add('body-overflow')
            } else {
                this.clicked = false
                document.querySelector('body').classList.remove('body-overflow')
            }
        },

        routeTo(obj){
            this.cursosClicked()
            this.$router.push(obj)
        },
    },

    mounted() {
        var self = this
            window.addEventListener("scroll", function(e){
                var h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';
    
                self.scrollPercentage = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100
            })
    },

    computed: {

        objPages(){
            return _.keyBy(this.pages, 'id')
        },

        pages(){
            return this.$store.state.page.all
        },

        styleComputed(){
            this.concurso = false;
            var percent = 1;

            if (screen.width > 992) {
                percent = 0.40;
                if(this.scrollPercentage > 0){
                    this.logo = "logo-concurso.png"
                    percent = ((this.scrollPercentage / 100).toFixed(2) * 10) + percent;
                } else {
                    this.logo = "logo.png"
                }
            }

            return `background-color: rgba(20, 21, 34, ${percent});`
        },

        opacityLogo(){
            if(this.scrollPercentage > 0){
                if(((this.scrollPercentage) / 100).toFixed(2) * 10 > 1){
                    return `opacity: 1`
                } else {
                    return `opacity: ${((this.scrollPercentage) / 100).toFixed(2) * 10} !important;`
                }
            }
        },

        opacityLogoReverse(){
            if(this.scrollPercentage > 0){
                if(((this.scrollPercentage) / 100).toFixed(2) * 10 > 1){
                    return `opacity: 0`
                } else {
                    return `opacity: ${1 - (((this.scrollPercentage) / 100).toFixed(2) * 10)} !important;`
                }
            }
        },

        orange(){
            return (this.$route.params.page == 'concurso-de-bolsas')
        },

        cursos(){
            return this.$store.state.post.cursosApi
        },

        cursosOrdened(){
            return Array.from(new Set(this.cursos.map(e => e.area)))
        },

    },
}
</script>
<style scoped>
.relative {
    position: relative;
}

.height-20{
    height: 20px;
}

.search {
    position: fixed;
    right: 0;
    width: 100%;
    left: auto;
    z-index: 9999999;
    top: 14px;
    opacity: 1;
    overflow: auto;
    background: #FFF;
    left: 0;
    margin: 77px auto 0;
    box-shadow: 0px 0px 11px #000;
}

.search-inside {
    padding: 5px 10px 5px;
}

.search input {
    width: 100%;
    border: 0;
    outline: none;
}

.search button {
    background: #FF0202;
    border: 0px;
    border-radius: 0;
    color: #FFF;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 32px;
}

.search button.btn-search {
    background: url(/wp-content/themes/rhiza/dist/assets/btn-enviar.png) center center;
    margin: 0 10px 0 0;
}

.slide-enter-active {
   -moz-transition-duration: 0.5s;
   -webkit-transition-duration: 0.5s;
   -o-transition-duration: 0.5s;
   transition-duration: 0.5s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.5s;
   -webkit-transition-duration: 0.5s;
   -o-transition-duration: 0.5s;
   transition-duration: 0.5s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

.logo-box {
    position: relative;
}

.logo-bauhaus-white,
.logo-bauhaus-red {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
}

.logo-bauhaus-white img,
.logo-bauhaus-red img {
    width: 100%;
}

.logo-bauhaus-red {
    opacity: 0;
}

.navbar-brand {
    width: 175px;
    height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Header.vue